// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1OMHD","menu":"Footer_menu__3CEGn","contactList":"Footer_contactList__3OrqO"};